import React from 'react';
import useSound from 'use-sound';
import { uid } from 'react-uid';

import sfxUserPost from '../assets/sfx/chat_sfx_post.mp3';
import { MessageSender } from '../types/shared';

export const INTRO_MESSAGE_1 = 'Hey there! I can answer common questions about your benefits.';
export const INTRO_MESSAGE_2 =
  "For complex questions, type “Contact HR” and I'll give you the info for your employer's very own benefits genius.";
export const INTRO_QUESTIONS = [
  "What's my deductible?",
  'How is mental health covered?',
  'How do I find an in-network doctor?',
];

export interface IntroProps extends MessageSender {
  chatId: string;
  hidden: boolean;
}

function Intro({ chatId, hidden, sendMessage }: IntroProps): JSX.Element | null {
  const [play] = useSound(sfxUserPost);

  if (hidden) {
    return null;
  }

  const introClick = (message: string): void => {
    // this error is handled in ChatWindowContainer useMutation call
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    sendMessage({
      variables: {
        id: chatId,
        textBody: message,
      },
    }).then(() => {
      play();
    });
  };

  return (
    <div className="Intro">
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex  */}
      <div tabIndex={0} className="Intro-message" data-testid="intro-message-1">
        {INTRO_MESSAGE_1}
      </div>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex  */}
      <div tabIndex={0} className="Intro-message" data-testid="intro-message-2">
        {INTRO_MESSAGE_2}
      </div>
      {INTRO_QUESTIONS.map((question, index) => {
        return (
          <button
            type="button"
            className="Intro-button"
            data-testid="intro-button"
            onClick={(): void => introClick(question)}
            key={uid(index)}
          >
            {question}
          </button>
        );
      })}
    </div>
  );
}

export default Intro;
